export const getToken = () => localStorage.getItem("noxai_token");

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("noxai_user"));
  } catch {
    return null;
  }
};

export const setAuth = (token, user) => {
  localStorage.setItem("noxai_token", token);
  localStorage.setItem("noxai_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("noxai_token");
  localStorage.removeItem("noxai_user");
};
